import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash-es';
/* Models */
import { InventoryEntities } from 'client/data/models/inventory';
/* Utils */
import { EventToolbox } from 'client/utils/event-toolbox';
import { getDealStatusTrackingValue } from 'site-modules/shared/utils/financing/get-deal-status-tracking-value';
/* Constants */
import { PRIVATE_PARTY_EVENTS } from 'site-modules/shared/constants/private-party/private-party-events';
import {
  CARAMEL_MAKE_AN_OFFER_CTA,
  CARAMEL_ENTRY_POINT_PRIVATE_DATA,
} from 'site-modules/shared/constants/financing/caramel';
import {
  CREATIVE_ID_SELLER_DESCRIPTION,
  CREATIVE_ID_SUMMARY_CHECKOUT,
} from 'client/site-modules/shared/constants/private-party/tracking';
/* Components */
import { CaramelLogo } from 'site-modules/shared/components/financing/caramel/components/caramel-logo/caramel-logo';
import { CaramelBenefits } from 'site-modules/shared/components/financing/caramel/components/caramel-benefits/caramel-benefits';
import { CaramelCta } from 'site-modules/shared/components/financing/caramel/components/caramel-cta/caramel-cta';

import './seller-info.scss';

export function SellerInfo({ vinData = {}, handlePrivatePartyMakeOffer = noop, dealer = null, enableCaramel = false }) {
  const { sellerInfo } = vinData;
  const dealStatus = dealer?.dealStatus;
  const dealStatusTrackingValue = getDealStatusTrackingValue({ dealStatus, additionalValue: '-main-container' });

  const handleCaramelMakeOffer = useCallback(() => {
    EventToolbox.fireCustomEvent(PRIVATE_PARTY_EVENTS.SUMMARY_CHECKOUT, {
      creativeId: CREATIVE_ID_SELLER_DESCRIPTION,
      value: CARAMEL_MAKE_AN_OFFER_CTA,
    });
    return handlePrivatePartyMakeOffer();
  }, [handlePrivatePartyMakeOffer]);

  return (
    <div
      className="seller-info-wrapper"
      data-tracking-parent={
        dealStatus ? `${CREATIVE_ID_SUMMARY_CHECKOUT}${dealStatusTrackingValue}` : CREATIVE_ID_SELLER_DESCRIPTION
      }
    >
      <div className="size-20 fw-bold text-cool-gray-10">
        Private Seller - {sellerInfo?.address?.city}, {sellerInfo?.address?.stateCode}
      </div>
      {enableCaramel && (
        <>
          <hr className="mt-0_5 mb-1" />
          <div className="text-cool-gray-30 fw-bold">Simple, Secure Checkout</div>
          <CaramelLogo />
          <CaramelBenefits benefits={CARAMEL_ENTRY_POINT_PRIVATE_DATA.benefits} />
          <CaramelCta
            cta={CARAMEL_MAKE_AN_OFFER_CTA}
            handleCaramelMakeOffer={handleCaramelMakeOffer}
            dealStatus={dealStatus}
            isPrivateListing
          />
          {dealStatus && (
            <div className="flag-container pos-r bg-yellow-60 text-cool-gray-10 fw-bold text-center py-0_25">
              {dealStatus}
              <i className="icon-info size-10 ms-0_25" aria-hidden />
            </div>
          )}
        </>
      )}
    </div>
  );
}

SellerInfo.propTypes = {
  vinData: InventoryEntities.InventoryVin,
  handlePrivatePartyMakeOffer: PropTypes.func,
  dealer: PropTypes.shape({}),
  enableCaramel: PropTypes.bool,
};
